import { useState } from 'react'

export function useIsLoading(): [
  isLoading: boolean,
  startLoading: () => void,
  stopLoading: () => void,
] {
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const startLoading = () => setIsLoading(true)
  const stopLoading = () => setIsLoading(false)

  return [isLoading, startLoading, stopLoading]
}
